import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { useParams } from 'react-router-dom';
import { ICreateSupportTicketMainState } from '../CreateSupportTicketDialog';
import { onConfirmCreateSupportTicket } from '../../../../../redux/project/sliceProjectSupportTicketCreation';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({
    setShowErrorState,
    mainState,
    onClose,
}: ICreateSupportTicketDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'createSupportTicketDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const params = useParams();

    const { replicaId } = params;

    const { loading: loadingCreateSupportTicketData } = useSelector(
        (_store: IAppReduxStore) => _store.projectSupportTicketCreation,
    );

    const { loading: loadingDocuments } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );

    const validateInput = () => {
        setShowErrorState(prevState => ({
            ...prevState,
            templateUNID: !mainState.templateUNID,
            body: !mainState.body,
        }));
        return mainState.templateUNID && mainState.body;
    };

    const onCreateSupportTicket = () => {
        if (validateInput()) {
            dispatch(
                onConfirmCreateSupportTicket({
                    ...mainState,
                    replicaId,
                }),
            );
        }
    };

    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button variant={'text'} onClick={onClose} sx={{ ...buttonSx, color: vars.font }}>
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onCreateSupportTicket}
                sx={buttonSx}
                disabled={loadingDocuments || loadingCreateSupportTicketData}
            >
                {t('ctaSend')}
            </Button>
        </DialogActions>
    );
};

interface ICreateSupportTicketDialogActionsProps {
    setShowErrorState: Dispatch<
        React.SetStateAction<{ [P in keyof ICreateSupportTicketMainState]?: boolean }>
    >;
    mainState: ICreateSupportTicketMainState;
    onClose: () => void;
}
